import theme, { isDark } from 'theme';

import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  error: {
    color: isDark()
      ? theme.palette.error.dark : theme.palette.error.light,
  },
  valid: {
    color: isDark()
      ? theme.palette.primary.dark : theme.palette.primary.light,
  },
  disabled: {
    color: theme.palette.grey[500],
  },
});
